module.exports = __webpack_public_path__ + "img/www.hungerstation.com.4a796267.png";